import React from 'react';

import cn from 'classnames';

import Img from '@modules/shared/components/Img';

import AdultIcon from '../../../../../../assets/images/Adult.svg';
import FemaleAdultIcon from '../../../../../../assets/images/FemaleAdult.svg';
import FemaleYouthIcon from '../../../../../../assets/images/FemaleYouth.svg';
import YouthIcon from '../../../../../../assets/images/Youth.svg';
import styles from './Placeholder.less';

type Props = {
  pictureUrl?: string;
  isAdult: boolean;
  isFemale: boolean;
};

const Placeholder: React.FC<Props> = ({ pictureUrl, isAdult, isFemale }) => {
  if (pictureUrl)
    return <Img src={pictureUrl} className={styles.personAvatar} />;

  if (isAdult)
    return isFemale ? (
      <FemaleAdultIcon
        className={cn(styles.placeholderIcon, styles.adultIcon)}
        role="img"
      />
    ) : (
      <AdultIcon
        className={cn(styles.placeholderIcon, styles.adultIcon)}
        role="img"
      />
    );

  return isFemale ? (
    <FemaleYouthIcon
      className={cn(styles.placeholderIcon, styles.youthIcon)}
      role="img"
    />
  ) : (
    <YouthIcon
      className={cn(styles.placeholderIcon, styles.youthIcon)}
      role="img"
    />
  );
};

export default Placeholder;
